import { SpotAndGreeks } from 'components/common-form/builder/form/node/field/SpotAndGreeksField/SpotAndGreeksField/SpotAndGreekField.connect';
import { displayUnderlyingCode } from 'components/common-form/builder/form/node/field/utils';
import type { Underlying } from 'models/underlying';
import type { ForexGreekLine, GreekLine, GreeksTable } from 'state/quotes/details/details.model';

export function getSpotAndGreeksForex(
  greeksEntry: Nullable<GreeksTable>,
  underlyings: readonly Underlying[] | undefined,
): SpotAndGreeks[] {
  const underlying = underlyings?.find(u => u.asset === 'Forex');
  const cells = (greeksEntry?.cells ?? []) as unknown as ForexGreekLine[];
  const spot = cells.find(c => c.name === 'Spot' && c.reference === underlying?.name)?.value;
  const fxDelta = cells.find(c => c.name === 'FxRisks' && c.reference?.includes('FxDelta'));
  const fxVega = cells.find(c => c.name === 'FxRisks' && c.reference?.includes('FxVega'));
  return [
    {
      underlying,
      spot,
      isForex: true,
      fxDelta,
      fxVega,
    },
  ];
}

export function getSpotAndGreeksEquity(
  greeksEntry: Nullable<GreeksTable>,
  underlyings: readonly Underlying[],
): SpotAndGreeks[] {
  return (
    greeksEntry?.cells
      .filter(greekLine => getUnderlying(underlyings, greekLine) !== undefined)
      .map(greekLine => ({
        underlying: getUnderlying(underlyings, greekLine),
        spot: greekLine.Spot as number,
        deltaPct: greekLine.DeltaPct as number,
        vega: greekLine.Vega as number,
        vegaEuro: greekLine.VegaEuro as number,
        deltaInShare: greekLine.DeltaInShare as number,
      })) ?? []
  );
}

function getUnderlying(underlyings: readonly Underlying[], greekLine: GreekLine) {
  return underlyings.find(
    u =>
      displayUnderlyingCode('Reuters', u) === greekLine.Name ||
      displayUnderlyingCode('Bloomberg', u) === greekLine.Name,
  );
}

export const decimalRules = {
  Forex: {
    spot: {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    },
    fxDelta: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    fxVega: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },
  Equity: {
    spot: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    deltaPct: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    deltaInShare: {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    },
    vega: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  },
};
